import { CRUDAction } from 'common/constants/permission'
import { usePermitByFeatures } from 'modules/user/api/selector'
import { ReactNode } from 'react'

interface PermissionGuardProps {
  featureKeys: string[]
  children: ReactNode
  crud?: number
}

export default function PermissionGuard({
  featureKeys,
  children,
  crud = CRUDAction.Read,
}: PermissionGuardProps) {
  const permitted = usePermitByFeatures(crud, featureKeys)

  if (!permitted) {
    return null
  }

  return <>{children}</>
}
